import type { GallerySection } from "../../content/industry";
import { Photo } from "./Photo";
import { SectionHeading } from "./SectionHeading";

/**
 * Galería con tres composiciones: «facilities» (retícula con leyendas numeradas), «portfolio» (mosaico de columnas con
 * fotos verticales) y «strip» (tira horizontal con desplazamiento por pasos, navegable con teclado).
 */
export function Gallery({ section }: { section: GallerySection }) {
  return (
    <section id={section.id} className={`ix-section ix-gallery ix-gallery--${section.variant}`} aria-labelledby={`${section.id}-title`}>
      <div className="ix-container">
        <SectionHeading id={section.id} eyebrow={section.eyebrow} title={section.title} text={section.text} />
        <ul className="ix-gallery-items" tabIndex={section.variant === "strip" ? 0 : undefined} aria-label={section.variant === "strip" ? `${section.title} (desplázate horizontalmente)` : undefined}>
          {section.items.map((item, index) => <li key={`${item.image}-${item.caption}`}>
            <figure>
              <Photo index={item.image} sizes={section.variant === "strip" ? "(min-width: 1024px) 40vw, 80vw" : "(min-width: 1024px) 33vw, 100vw"} />
              <figcaption><span>{String(index + 1).padStart(2, "0")}</span> {item.caption}</figcaption>
            </figure>
          </li>)}
        </ul>
      </div>
    </section>
  );
}
